import Home from './home'

export default Home